var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-run-interpretation',{attrs:{"is-archive-mode":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }